exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes kv-shimmer-anim-348ce65f {\n0% {\n    background-position: -200% 0;\n}\n100% {\n    background-position: 200% 0;\n}\n}\n.kv-skeleton[data-v-348ce65f] {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  --sk-base: #f0f2f5;\n  --sk-highlight: #e6e8eb;\n}\n.kv-skeleton .kv-bone[data-v-348ce65f] {\n  background: linear-gradient(90deg, var(--sk-base) 25%, var(--sk-highlight) 50%, var(--sk-base) 75%);\n  background-size: 200% 100%;\n  animation: kv-shimmer-anim-348ce65f 1.5s infinite;\n  border-radius: 4px;\n}\n.kv-skeleton .kv-bone.footer[data-v-348ce65f] {\n  align-self: flex-end;\n}\n", ""]);

// exports
